import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tab } from "@pentabd/ui";

import {
  SettingsOfficeHeader,
  OfficeAddress,
  UserManual,
  EmailUpdate,
  ResetPassword,
} from "./components";

import { useUser } from "@hooks/useUser";
import { getAccess } from "@helpers/permissionController";

const HRMSettings = () => {
  const scrollToTopRef = useRef<any>(null);

  const { t } = useTranslation();
  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const [currentTab, setCurrentTab] = useState(0);
  const handleActiveTab = (tabIndex: number) => setCurrentTab(tabIndex);

  const handleScrollToTop = () => {
    if (scrollToTopRef.current) {
      scrollToTopRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const tabData = [
    {
      label: t("HRM_SETTINGS.TABS.OFFICE_ADDRESS"),
      component: <OfficeAddress handleScrollToTop={handleScrollToTop} />,
    },
    {
      label: t("HRM_SETTINGS.TABS.USER_MANUAL"),
      component: <UserManual />,
    },
    {
      ...(getAccess(roles, "CAN_EDIT_USER_CREDENTIAL") && {
        label: t("HRM_SETTINGS.TABS.EMAIL_UPDATE"),
        component: <EmailUpdate />,
      }),
    },
    {
      ...(getAccess(roles, "CAN_EDIT_USER_CREDENTIAL") && {
        label: t("HRM_SETTINGS.TABS.RESET_PASSWORD"),
        component: <ResetPassword />,
      }),
    },
  ];

  return (
    <div className="container p-10" ref={scrollToTopRef}>
      <SettingsOfficeHeader />
      <div className="pt-10">
        <Tab active={currentTab} setActiveTab={handleActiveTab}>
          <Tab.Heads>
            {tabData.map(({ label }, i) => (
              <Tab.Item key={i} index={i} label={label} />
            ))}
          </Tab.Heads>
          <Tab.ContentWrapper>
            {tabData.map(({ component }, i) => (
              <Tab.Content key={i} index={i}>
                {component}
              </Tab.Content>
            ))}
          </Tab.ContentWrapper>
        </Tab>
      </div>
    </div>
  );
};

export default HRMSettings;
